function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1451 417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.9,303.8c-12.4,0 -23.3,-3 -32.5,-8.9c-9.3,-6 -16.5,-14.4 -21.7,-25.3c-5.2,-10.9 -7.8,-23.5 -7.8,-37.9c0,-12.8 3,-24.4 9,-34.9c6,-10.5 14,-18.9 23.9,-25.3c9.9,-6.4 20.8,-9.6 32.5,-9.6c9,0 17.1,1.8 24.1,5.3c7,3.5 12.5,8.4 16.4,14.7c1.3,2 2.4,4.4 3.4,7c2.1,5.5 3.7,14 3,20.4c-1.6,14.1 -6.1,14.2 -14.1,14.2c-13.9,0 -68,0.9 -68,0.9c-3.2,0 -7.9,1.8 -8.5,7c-0.9,7.4 2.4,14.9 7.1,23.7c4.7,8.7 11.1,15.7 19,20.8c7.9,5.2 16.6,7.8 26.1,7.8c6.8,0 12.9,-1.3 18.5,-3.8c5.5,-2.5 9.7,-6.5 14,-11.3c0.9,-1.1 1.7,-2 2.1,-2.4c0.5,-0.5 1.5,-1.5 2.2,-1.6c1.6,-0.3 4.8,1.8 5,4c0.4,4.2 -4.2,9.8 -8.3,14.8c-3.4,4.2 -7.5,7.8 -12.2,10.9c-4.7,3.1 -9.9,5.5 -15.6,7.1c-5.7,1.7 -11.5,2.5 -17.6,2.5Zm-33.6,-94.9c2.7,1.9 32.9,1.3 32.9,1.3c5.5,-0.3 11.1,-0.2 15,-0.4c3.8,-0.2 9.8,-0.7 11.8,-1.8c1.5,-0.8 2.8,-2 3.3,-4.8c0.7,-3.9 0.3,-6.3 -0,-8.4c-0.9,-6.5 -4.8,-11.9 -10.6,-16.4c-5.8,-4.5 -12.6,-6.8 -20.5,-6.8c-5.2,0 -10.4,1.5 -15.6,4.5c-5.2,3 -9.5,6.7 -12.9,11.1c-3.4,4.4 -5,9.1 -5.5,13.5c-0.3,2.2 -0.8,6.3 2.1,8.4Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.7,303.8c-12.4,0 -23.3,-3 -32.5,-8.9c-9.3,-6 -16.5,-14.4 -21.7,-25.3c-5.2,-10.9 -7.8,-23.5 -7.8,-37.9c0,-12.8 3,-24.4 9,-34.9c6,-10.5 14,-18.9 23.9,-25.3c9.9,-6.4 20.8,-9.6 32.5,-9.6c9,0 17.1,1.8 24.1,5.3c7,3.5 12.5,8.4 16.4,14.7c1.3,2 2.4,4.4 3.4,7c2.1,5.5 3.7,14 3,20.4c-1.6,14.1 -6.1,14.2 -14.1,14.2c-13.9,0 -68,0.9 -68,0.9c-3.2,0 -7.9,1.8 -8.5,7c-0.9,7.4 2.4,14.9 7.1,23.7c4.7,8.7 11.1,15.7 19,20.8c7.9,5.2 16.6,7.8 26.1,7.8c6.8,0 12.9,-1.3 18.5,-3.8c5.5,-2.5 9.7,-6.5 14,-11.3c0.9,-1.1 1.7,-2 2.1,-2.4c0.5,-0.5 1.5,-1.5 2.2,-1.6c1.6,-0.3 4.8,1.8 5,4c0.4,4.2 -4.2,9.8 -8.3,14.8c-3.4,4.2 -7.5,7.8 -12.2,10.9c-4.7,3.1 -9.9,5.5 -15.6,7.1c-5.7,1.7 -11.5,2.5 -17.6,2.5Zm-33.6,-94.9c2.7,1.9 32.9,1.3 32.9,1.3c5.5,-0.3 11.1,-0.2 15,-0.4c3.8,-0.2 9.8,-0.7 11.8,-1.8c1.5,-0.8 2.8,-2 3.3,-4.8c0.7,-3.9 0.3,-6.3 -0,-8.4c-0.9,-6.5 -4.8,-11.9 -10.6,-16.4c-5.8,-4.5 -12.6,-6.8 -20.5,-6.8c-5.2,0 -10.4,1.5 -15.6,4.5c-5.2,3 -9.5,6.7 -12.9,11.1c-3.4,4.4 -5,9.1 -5.5,13.5c-0.3,2.2 -0.8,6.3 2.1,8.4Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.2,304.2c-1.1,0 -2.5,-0.2 -4.2,-0.5c-1.7,-0.3 -2.5,-1.1 -2.5,-2.4c0,-1.7 0.8,-3 2.5,-3.7c1.7,-0.8 3.4,-1.4 5.3,-2.1c3.4,-1.1 6.7,-2.3 9.8,-3.7c3.2,-1.4 4.7,-4.2 4.7,-8.5l0,-162.3c0,-6.2 -1.2,-11.4 -3.6,-15.6c-2.4,-4.2 -6.4,-6.8 -12,-7.9c-1.8,-0.4 -2.7,-1.8 -2.7,-4.2c0,-2.1 0.8,-3.4 2.4,-3.9c5.9,-1.3 11,-2.6 15.3,-4c4.3,-1.4 8.3,-2.8 12,-4.3c3.7,-1.5 7.4,-2.9 11,-4.2c0.9,-0.4 1.6,-0.6 2,-0.6c0.5,0 0.8,0.3 1.2,0.8c0.3,0.5 0.5,1 0.5,1.4c0,1.9 -0.4,6.1 -1.2,12.4c-0.8,6.3 -1.2,16.8 -1.2,31.4l0,161c0,4.3 1.6,7.1 4.7,8.5c3.2,1.4 6.4,2.6 9.8,3.7c1.8,0.6 3.6,1.3 5.3,2.1c1.7,0.8 2.5,2 2.5,3.7c0,1.3 -0.8,2.1 -2.5,2.4c-1.7,0.3 -3.1,0.5 -4.2,0.5c-4.3,0 -7.7,-0.2 -10.3,-0.5c-2.6,-0.3 -5.1,-0.6 -7.5,-0.8c-2.4,-0.2 -5.6,-0.3 -9.7,-0.3c-3.8,0 -7,0.1 -9.5,0.3c-2.5,0.2 -5,0.5 -7.5,0.8c-2.5,0.3 -6,0.5 -10.5,0.5Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.1,302.2c-1,-0.3 -8.6,-2.9 -10.2,-3.7c-3.1,-1.6 -5.9,-2.9 -7.7,-4.2c-3.5,-2.6 -4.5,-2.9 -5.9,-4.2c-1.2,-1 -2.9,-2.3 -3.6,-3c-1.2,-1.1 -6.2,-6.8 -10.4,-12.9c-3.4,-4.9 -7.3,-13 -11.7,-20.6c-0.8,-1.4 -1.4,-2.5 -1.9,-3.3c-3.6,-6.4 -0.1,-0.2 -9.6,-17.2c-0.1,-0.2 -6.1,-11.2 -6.1,-11.2c0,0 -6.4,-10.6 -7.5,-11.9c-1.4,-1.7 -1.8,-2.2 -2.1,-2.5c-0.4,-0.4 -0.3,-0.5 -2.6,-2.4c-4.3,-3.6 -9.3,-5.1 -14.1,-6.1c-4.9,-1 -8.9,-1.7 -12,-1.9c-1.8,-0.2 -3.1,0.3 -3.9,1.7c-0.8,1.4 -1.2,3.1 -1.2,5.2l0,60.5c0,7.3 1.7,13.7 5.1,19.1c3.4,5.4 9.3,8.9 17.6,10.5c3.8,0.7 6.7,1.5 8.5,2.4c1.8,0.9 2.7,2.2 2.7,3.8c0,1.4 -0.9,2.3 -2.7,2.9c-1.8,0.6 -4.2,0.9 -7.1,0.9c-6.1,0 -10.8,-0.2 -14.1,-0.7c-3.3,-0.5 -6.2,-0.9 -8.8,-1.2c-2.6,-0.3 -6,-0.5 -10.3,-0.5c-5.7,0 -10.7,0.2 -15.1,0.5c-4.4,0.3 -8.8,0.7 -13.2,1.2c-4.4,0.5 -9.7,0.7 -15.8,0.7c-2.9,0 -5.3,-0.3 -7.1,-0.9c-1.8,-0.6 -2.7,-1.5 -2.7,-2.9c0,-2.8 3.7,-4.8 11.2,-6.2c8.6,-1.6 14.9,-4.2 18.8,-7.9c4,-3.7 5.9,-9.7 5.9,-18.2l0,-146.5c0,-8.7 -0.4,-15.3 -1.2,-19.8c-0.8,-4.5 -2.6,-7.6 -5.4,-9.5c-2.8,-1.8 -7.5,-3.1 -14.1,-3.8c-3.8,-0.5 -6.7,-1.3 -8.5,-2.6c-1.8,-1.3 -2.7,-2.7 -2.7,-4.3c0,-1.4 0.9,-2.3 2.7,-2.9c1.8,-0.6 4.2,-0.9 7.1,-0.9l13.7,0c3.1,0 5.9,0.1 8.6,0.2c2.7,0.1 6.3,0.2 10.8,0.2c4.3,0 8.1,-0.2 11.5,-0.5c3.4,-0.3 7.2,-0.6 11.4,-0.9c4.2,-0.2 9.5,-0.3 16.1,-0.3c24.9,0 43.8,4.7 56.8,14.1c13,9.4 19.5,23.5 19.5,42.3c0,10.3 -2,19.2 -6.1,26.7c-4.1,7.5 -9.2,13.7 -15.3,18.7c-6.1,5 -12.3,9.2 -18.6,12.4c-0.8,0.4 -1.4,0.7 -2.2,1.3c-0.7,0.4 -6.3,2.8 -5.6,4c9.1,9 22,32.2 26.5,40.2c2.4,4.2 3.7,6.6 7.3,12.7c1.6,2.7 4.6,7.7 8.1,11.8c5.2,6.1 16.7,17.2 20.9,19.7c22.3,13.1 32.5,23.1 16.8,23.9c-2.9,0.1 -6.4,0.7 -11.6,0c-5.4,-0.7 -6.4,-1 -8.9,-1.7Zm-92.6,-113.1c10.4,0 19.4,-2.4 27,-7.2c7.6,-4.8 13.4,-11.1 17.6,-18.9c4.2,-7.8 6.3,-16 6.3,-24.8c0,-9.4 -1.2,-18 -3.6,-25.8c-2.4,-7.8 -7.1,-14 -14.2,-18.7c-7.1,-4.7 -17.8,-7 -32,-7c-7.2,0 -12,2.3 -14.2,7c-2.3,4.7 -3.6,13 -4.1,24.9c-0.2,5.7 -0.4,13.5 -0.5,23.2c-0.1,9.7 -0.2,21.5 -0.2,35.2c0,5.7 1.6,9.2 4.7,10.3c3.2,1.1 7.6,1.7 13.2,1.7Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.4,303.4c-7,0 -13.6,-1 -19.7,-3.1c-6.1,-2.1 -11.3,-5 -15.6,-8.8c-1.1,-2.4 -2,-6.5 -2.5,-12.2c-0.6,-5.7 -1,-10.5 -1.2,-14.2c0,-2 1.5,-3 4.4,-3c0.9,0 1.8,0.2 2.5,0.5c0.8,0.3 1.3,0.9 1.5,1.8c2.9,10.8 7.6,18.5 14.1,23.1c6.4,4.6 12.9,6.9 19.5,6.9c6.6,0 12.1,-2.1 16.8,-6.4c4.6,-4.3 6.9,-9.6 6.9,-16c0,-6 -2,-11.1 -6.1,-15.4c-4.1,-4.3 -11.2,-9.5 -21.4,-15.7c-7.7,-4.6 -13.9,-9 -18.6,-13.2c-4.7,-4.2 -8.2,-8.5 -10.3,-12.9c-2.1,-4.4 -3.2,-9.4 -3.2,-14.9c0,-7.1 1.7,-13.4 5.1,-19.2c3.4,-5.7 8.5,-10.3 15.3,-13.7c6.8,-3.4 15.3,-5.1 25.4,-5.1c6.8,0 12.4,0.7 17,2c4.5,1.3 7.9,2.8 10.2,4.3c1.8,2.4 3.3,6.2 4.6,11.4c1.2,5.2 1.9,10.1 1.9,14.7c0,1.5 -1.1,2.3 -3.4,2.3c-1.4,0 -2.7,-0.3 -3.9,-0.8c-1.2,-0.6 -2.1,-1.3 -2.5,-2.1c-2.9,-7.3 -6.6,-12.8 -11,-16.7c-4.4,-3.9 -9.9,-5.8 -16.4,-5.8c-5.7,0 -10.7,1.7 -15.1,5c-4.4,3.3 -6.6,8.2 -6.6,14.6c0,5.1 1.6,9.6 4.9,13.6c3.3,4 9.4,8.5 18.5,13.6c13.1,7.3 22.9,14.1 29.3,20.3c6.4,6.3 9.7,14.6 9.7,25c0,11.9 -4.6,21.6 -13.9,29.1c-9.3,7.5 -21.2,11.2 -35.9,11.2Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.2,303.4c-11.1,0 -19.7,-3.3 -25.9,-9.9c-6.2,-6.6 -9.3,-16.4 -9.3,-29.4l0,-76.7c0,-1.8 -0.7,-3 -2,-3.8c-1.4,-0.8 -4.3,-1.2 -8.8,-1.2l-2,0c-1.1,-0 -2.1,-0.7 -2.9,-2.1c-0.8,-1.4 -1.2,-2.9 -1.2,-4.5c0,-0.4 0.3,-1.1 1,-2c0.7,-0.9 1.1,-1.4 1.4,-1.7c4.5,-3.1 8.6,-6.2 12.4,-9.3c3.7,-3.1 7.1,-6.1 10.2,-9.1c3.1,-3 5.6,-5.7 7.6,-8.1c1.1,-1.1 2.1,-2 2.9,-2.8c0.8,-0.8 1.8,-1.2 2.9,-1.2c1.1,0 2.2,0.2 3.2,0.7c1,0.4 1.4,1.4 1.2,3l-1.7,14.9c-0.2,2.4 0.3,4.1 1.7,5c1.4,0.9 3.5,1.3 6.4,1.3l38.6,0c0.9,-0 1.7,0.7 2.4,2.1c0.7,1.4 1,3.1 1,5.1c0,2 -0.3,3.9 -1,5.8c-0.7,1.9 -1.5,2.8 -2.4,2.8l-33.6,0c-5.7,-0 -9.3,0.4 -11,1.3c-1.7,0.9 -2.5,3.5 -2.5,7.9l0,65.1c0,8.8 1.9,15.8 5.8,20.8c3.8,5.1 9.4,7.6 16.6,7.6c6.6,0 11.6,-0.5 15.3,-1.5c3.6,-1 6.9,-2.5 9.8,-4.5c0.5,-0.4 0.9,-0.7 1.4,-0.7c0.9,0 1.5,0.5 1.9,1.5c0.3,1 0.5,2 0.5,3.1c0,1.1 -1.9,3.3 -5.6,6.6c-3.7,3.3 -8.6,6.4 -14.6,9.3c-6,2.9 -12.5,4.3 -19.5,4.3Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.7,318c6.7,0 9.5,9.7 -0.1,10.8c-4.7,0.5 -9.1,0.6 -13.7,0.6c-19.4,0 -38.7,-3.3 -58,-9.8c-19.2,-6.5 -36.6,-16.5 -52.1,-30c-15.5,-13.5 -28,-30.5 -37.5,-51.1c-9.5,-20.6 -14.3,-45 -14.3,-73.2c0,-23.3 3.9,-44.9 11.8,-64.8c7.9,-19.9 18.9,-37 33,-51.4c14.1,-14.4 31.1,-25.7 51.1,-33.9c20,-8.2 42,-12.3 65.9,-12.3c19.1,0 38.3,3.3 57.5,10c19.2,6.7 36.5,16.7 51.8,30.2c15.3,13.5 27.7,30.5 37.3,51.1c9.5,20.6 14.3,44.9 14.3,72.7c0,23.6 -3.5,44.6 -10.5,62.7c-6.6,17.3 -16.6,33.9 -22.4,38.5c-4.7,3.8 -16.2,-2.7 -11.7,-13.4c1.9,-4.5 3.6,-10.3 3.7,-10.3c4.2,-14.7 6.1,-30.5 5.5,-47.5c-0.9,-23.6 -5.1,-46.5 -12.5,-68.7c-7.4,-22.1 -17.5,-41.8 -30.2,-58.9c-12.7,-17.1 -27.7,-30.8 -45,-40.9c-17.3,-10.2 -36.1,-15.2 -56.4,-15.2c-17.3,0 -32.7,3 -46.1,9.1c-13.5,6.1 -24.9,14.6 -34.1,25.7c-9.2,11.1 -16.1,24.3 -20.7,39.8c-4.5,15.5 -6.5,32.4 -5.9,50.9c0.9,22.7 5.1,44.9 12.5,66.4c7.4,21.5 17.6,40.6 30.5,57.3c12.9,16.7 28,30.1 45.2,40.2c17.3,10.2 30.8,15.2 51.1,15.2Z",
    style: {
      fill: "#fdfcfc",
      stroke: "#fdfcfc",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.6,303.4c-8.8,0 -17.4,-1.4 -25.9,-4.1c-8.5,-2.7 -16.2,-6.9 -23.1,-12.6c-6.9,-5.6 -12.4,-12.8 -16.6,-21.6c-4.2,-8.7 -6.3,-19 -6.3,-30.8c0,-10.7 2,-20.5 5.9,-29.3c3.9,-8.8 9.2,-16.4 15.9,-22.6c6.7,-6.3 14.4,-11.2 23.1,-14.7c8.7,-3.5 17.7,-5.3 27,-5.3c8.6,0 17.2,1.3 25.7,4c8.5,2.6 16.1,6.8 22.9,12.4c6.8,5.6 12.3,12.8 16.6,21.6c4.3,8.7 6.4,19.2 6.4,31.4c0,11.6 -2.2,21.9 -6.6,30.8c-4.4,8.9 -10.1,16.4 -17,22.5c-7,6.1 -14.7,10.7 -23.2,13.8c-8.5,3.1 -16.8,4.6 -24.8,4.6Zm-50.8,-84.6c0,8.7 1.4,17.7 4.1,27c2.7,9.3 6.6,17.7 11.7,25.4c5,7.6 11.2,14 18.5,19c7.3,5 15.6,7.5 24.7,7.5c7.3,0 13.7,-1.4 19.1,-4.1c5.4,-2.7 9.8,-6.4 13.3,-10.9c3.5,-4.5 6,-9.9 7.7,-16c1.6,-6.1 2.5,-12.4 2.5,-19c0,-8.7 -1.5,-17.9 -4.5,-27.6c-3,-9.6 -7.2,-18.5 -12.5,-26.5c-5.3,-8 -11.7,-14.5 -19.2,-19.5c-7.5,-5 -15.7,-7.2 -24.7,-6.7c-7,0.2 -13,1.7 -18.1,4.5c-5.1,2.8 -9.3,6.5 -12.6,11.2c-3.3,4.6 -5.8,10 -7.4,16.1c-1.6,6.1 -2.5,12.6 -2.5,19.5Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fdfcfc",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "logoBlack.png"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1136.2,382.1c-35.9,-1.7 -263.6,-7.4 -470.2,7c-142.8,10 -240.5,23.9 -284.9,27.4c-1.2,0.1 -1.8,-1.9 -0.2,-2.5c3.8,-1.4 14.2,-3.2 18.5,-4c362.4,-67.1 907.7,-53.7 938.1,-38.8c10.7,5.2 9.2,18.7 5.1,20.9c-6.7,3.5 -16.1,-3.7 -206.4,-10Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,318.7c47.6,61.2 79.3,76.4 66.2,89c-11.7,11.2 -23.6,-13.3 -42.5,-37.9c-5.8,-7.5 -38.2,-50.6 -49.5,-54.6c-14.4,-5 -17,-2.4 -30.1,-21.2c-18.7,-26.8 -22.2,-31.4 -20.9,-32.7c3,-3 29.8,38.2 33.8,35.2c3.7,-2.8 -12.8,-21 -21,-32.3c-1.5,-2.1 -7.3,-8.7 -4.6,-9c3.3,-0.4 13.8,14.8 29.2,31.3c3.2,3.4 4.6,2.5 5.1,1.9c3.5,-3.8 -29.7,-36.9 -27.3,-39.3c1.8,-1.8 3.4,2.1 29.4,28.7c0.4,0.4 5.3,5.4 6.9,3.8c3.5,-3.5 -31.5,-36.6 -29.1,-39.4c1.6,-1.8 4.1,1.6 29.9,27.8c15.4,15.7 12.6,17.7 14.5,29.4c1.4,8.7 3,9.9 9.9,19.3Z",
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6,289.3c2.2,15.1 2.1,15.7 12,25.2c18.3,17.5 60.8,53.5 52.1,64.3c-10.5,12.9 -51.8,-50.4 -73.8,-74.9c-5.1,-5.7 -60.5,-67.4 -63.1,-71.8c-6.3,-10.4 29.9,6 53.9,29.7c17.5,17.3 16.2,18.6 18.9,27.4Z",
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.2,393.8c-0.3,1.1 -0.4,8.1 -11.2,8.2c-21.5,0.3 -37.4,-4.4 -44.8,-11c-10.5,-9.4 -10.4,-18 -2.4,-18c47.4,0 51.4,7.2 54.4,10.3c4.1,4.3 4.2,9.6 4,10.5Z",
    style: {
      fill: "url(#_Linear4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470.5,304.7c-1.1,0 -0.4,-7.5 -0.4,-11.8c0,-4.3 0.2,-8 0.2,-10.9l0,-2c-8.8,8.4 -17.7,14.4 -26.6,18c-8.9,3.6 -18.7,5.5 -29.3,5.5c-7.2,0 -13.8,-1.5 -19.7,-4.5c-5.9,-3 -10.5,-7.4 -13.9,-13.2c-3.4,-5.8 -5.1,-13.1 -5.1,-21.7l0,-67.1c0,-4.9 -1.1,-8.7 -3.4,-11.6c-2.3,-2.9 -6,-5.3 -11.2,-7.3c-1.1,-0.4 -2.1,-1 -3.1,-1.7c-0.9,-0.7 -1.4,-1.9 -1.4,-3.6c0,-2 0.5,-3.3 1.5,-4c1,-0.7 2.2,-1.1 3.6,-1.3c7.7,-0.4 13.6,-1 17.8,-1.8c4.2,-0.8 9.4,-1.9 15.8,-3.5c0.7,-0.2 1.2,-0.3 1.5,-0.3l1.2,0c2.5,0 3.6,1.5 3.4,4.6c-0.7,5.1 -1.2,9.3 -1.5,12.7c-0.3,3.4 -0.5,7.7 -0.5,12.7l0,64.5c0,5.3 1.4,10.2 4.1,14.7c2.7,4.5 6.3,8.2 10.7,11.1c4.4,2.9 9,4.3 13.7,4.3c5.9,0 11,-0.3 15.4,-1c4.4,-0.7 8.8,-2.5 13.1,-5.6c2.5,-1.8 5.7,-4.6 9.5,-8.6c3.8,-4 5.8,-9.4 5.8,-16.2l0,-60.5c0,-4.6 -1.4,-8.1 -4.2,-10.4c-2.8,-2.3 -6,-3.9 -9.7,-4.8c-3.6,-0.9 -6.6,-1.3 -8.8,-1.3c-2,0 -3.7,-0.4 -5.1,-1.2c-1.4,-0.8 -2,-2.3 -2,-4.5c0,-2 0.7,-3.3 2.2,-4c1.5,-0.7 3.1,-1 4.9,-1c7,-0.2 12.8,-0.5 17.5,-0.8c4.6,-0.3 8.8,-0.9 12.5,-1.7c3.7,-0.8 7.6,-1.7 11.7,-2.8c0.5,-0.2 1,-0.4 1.7,-0.5c0.7,-0.1 1.2,-0.2 1.7,-0.2c2.9,0 4.4,1.2 4.4,3.6c0,0.2 -0.1,0.6 -0.2,1.2c-0.1,0.6 -0.3,1.2 -0.5,1.8c-0.2,0.7 -0.5,2.5 -0.8,5.6c-0.3,3.1 -0.7,6.3 -1,9.6c-0.3,3.3 -0.5,5.8 -0.5,7.6l0,76.4c0,17.6 -1.2,21.2 5.3,23.9c1.1,0.4 5,2.3 8.7,3.5c5.3,1.7 10.6,3.2 10.6,6.3c0,3.5 -3.9,2.7 -4.8,2.6c-4.5,-0.5 -14.1,-1.1 -20.7,-1.1c-11.9,0 -22.8,2.1 -24,2.1Z",
    style: {
      fill: "#fdfcfc",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: "2.9px"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(965.823043,0,0,57.413812,379.791478,387.831756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe68e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#eed076",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#c29635",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#c89c3b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#dcb153",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#dfb35a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(102.480561,124.00891,-124.00891,102.480561,190.927035,270.215649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e9c465",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#caa141",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#bf9535",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#bf9332",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#cfa441",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#d4a94b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e2b764",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(132.93734,147.255928,-160.844659,145.204756,202.963155,231.267264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e9c465",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#deb859",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#bf9535",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#bf9332",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#cfa441",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#e1ba5a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e9c465",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64.866168,3.900842,-1.629215,27.091821,1377.635358,385.557324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dfb35a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#daae53",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#cea243",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c29634",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.a0b572e99688958dd36c59ff2b68cbca.svg";
export { ForwardRef as ReactComponent };